import { Row } from "@tanstack/react-table";
import { RefObject } from "react";

import { RowSelectionConditions } from "../selection";
import { TableData } from "../table";
import { OnRowClickFn } from "../table.types";
import { TableRow } from "./table_row";

type TableBodyProps<TABLE_DATA extends TableData> = {
  rows: Row<TABLE_DATA>[];
  onRowClick?: OnRowClickFn<TABLE_DATA>;
  compact?: boolean;
  noHover?: boolean;
  displayGrid?: boolean;
  topAlignContent?: boolean;
  lastRowRef: React.RefObject<HTMLTableRowElement | null> | undefined;
  renderExpandedRow?: (row: TABLE_DATA) => React.ReactNode;
  rowSelectionConditions?: RowSelectionConditions<TABLE_DATA>;
  scrollableContainerRef?: RefObject<HTMLElement | null>;
  hideDistantRows?: boolean;
  isInteractive?: boolean;
};

export const TableBody = <TABLE_DATA extends TableData>({
  rows,
  onRowClick,
  compact,
  topAlignContent,
  noHover,
  displayGrid,
  lastRowRef,
  renderExpandedRow,
  rowSelectionConditions,
  scrollableContainerRef,
  hideDistantRows,
  isInteractive
}: TableBodyProps<TABLE_DATA>) => (
  <tbody>
    {rows.map((row, index) => (
      <TableRow
        key={row.id}
        row={row}
        rowIndex={index}
        onRowClick={onRowClick}
        compact={compact}
        topAlignContent={topAlignContent}
        noHover={noHover}
        displayGrid={displayGrid}
        lastRowRef={rows.length - 1 === index ? lastRowRef : undefined}
        renderExpandedRow={renderExpandedRow}
        rowSelectionConditions={rowSelectionConditions}
        scrollableContainerRef={scrollableContainerRef}
        hideDistantRows={hideDistantRows}
        isInteractive={isInteractive}
      />
    ))}
  </tbody>
);
